(() => {
  'use strict';
  if (customElements.get('newsletter-form')) return;

  // Keep Shopify's native submission and hCaptcha handling intact.
  customElements.define('newsletter-form', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-newsletter-form]');
      if (!this.form) return;
      this.setSourceTags();
      this.onSubmit = () => {
        if (!this.form.checkValidity()) return;
        try { sessionStorage.setItem('newsletter_form_id', this.form.id); } catch (_) { /* Native submission still works. */ }
        const pending = this.form.querySelector('[data-newsletter-pending]');
        if (!pending) return;
        pending.hidden = false;
        pending.textContent = 'Validation en cours…';
        clearTimeout(this.pendingTimer);
        this.pendingTimer = setTimeout(() => {
          pending.textContent = 'La validation prend plus de temps. Réessayez dans quelques instants.';
        }, 15000);
      };
      // Capture intent before Shopify may pause submission while preparing CAPTCHA.
      this.onClick = (event) => {
        if (event.target.closest('button[type="submit"]')) this.onSubmit();
      };
      this.form.addEventListener('click', this.onClick, true);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.showResult();
    }

    setSourceTags() {
      const field = this.form.querySelector('[data-newsletter-source-tags]');
      if (!field) return;
      const tags = new Set(field.value.split(',').filter(Boolean));
      // Record only attribution present on the subscription page; no tracking storage.
      // Keep URLs, email addresses and click identifiers out of customer tags.
      const params = new URLSearchParams(window.location.search);
      ['source', 'medium', 'campaign'].forEach((key) => {
        const value = params.get(`utm_${key}`);
        if (value && /^[a-z0-9][a-z0-9 _-]{0,63}$/i.test(value)) {
          tags.add(`emiletter-utm-${key}-${value.toLowerCase().replace(/ +/g, '-')}`);
        }
      });
      if (!params.has('utm_source') && document.referrer) {
        try {
          const host = new URL(document.referrer).hostname.toLowerCase();
          const sources = [
            ['google', /(^|\.)google\.(com|fr|be|ch|de|co\.uk)$/],
            ['bing', /(^|\.)bing\.com$/],
            ['instagram', /(^|\.)instagram\.com$/],
            ['facebook', /(^|\.)(facebook\.com|fb\.com)$/],
            ['pinterest', /(^|\.)pinterest\.(com|fr)$/],
            ['tiktok', /(^|\.)tiktok\.com$/]
          ];
          const source = sources.find(([, pattern]) => pattern.test(host));
          if (source) tags.add(`emiletter-referent-${source[0]}`);
        } catch (_) { /* A missing referrer is unknown, never assumed to be direct. */ }
      }
      field.value = [...tags].join(',');
    }

    showResult() {
      let submittedId;
      try { submittedId = sessionStorage.getItem('newsletter_form_id'); } catch (_) { /* Storage can be unavailable. */ }
      const success = this.form.querySelector('[data-newsletter-success]');
      const error = this.form.querySelector('[data-newsletter-error]');
      if (!success && !error) return;
      const hash = window.location.hash.slice(1);
      // Shopify's current redirect takes precedence over a previous submission in this tab.
      const targetId = hash.startsWith('NewsletterForm--') ? hash : submittedId;
      if (targetId && targetId !== this.form.id) return;
      this.form.classList.toggle('has-success', Boolean(success));
      this.form.classList.toggle('has-error', !success && Boolean(error));
      if (success) {
        // The existing pop-up dismissal cookie is written only after server confirmation.
        document.querySelectorAll('[data-popup][data-cookie-name]').forEach((popup) => {
          if (!popup.querySelector('[data-newsletter-form]')) return;
          document.cookie = `${encodeURIComponent(popup.dataset.cookieName)}=user_has_closed; path=/; SameSite=Lax; Secure`;
        });
      }
      const message = success || error;
      const popup = this.closest('[data-popup]');
      if (!popup) {
        requestAnimationFrame(() => {
          message.focus({ preventScroll: true });
          this.form.scrollIntoView({ block: 'center', behavior: 'instant' });
        });
      }
    }

    disconnectedCallback() {
      clearTimeout(this.pendingTimer);
      this.form?.removeEventListener('click', this.onClick, true);
      this.form?.removeEventListener('submit', this.onSubmit, true);
    }
  });
})();
